export default __webpack_public_path__ + "static/media/Radar.29085297.mp4";